import {
  SIGNUP_HEADER_GROUP_VARIANTS,
  SIGNUP_HEADER_VARIANT,
  SignupHeaderVariant,
} from 'features/signup/constants';
import { ExperimentKey } from 'services/statsig/types';
import { useStatsig } from 'shared/hooks/statsig/useStatsig';

const useSignupHeaderExperiment = (): SignupHeaderVariant => {
  const { experimentSegmentActive } = useStatsig();

  const assignment = SIGNUP_HEADER_GROUP_VARIANTS.find(([groupName]) =>
    experimentSegmentActive(ExperimentKey.SIGNUP_PAGE_HEADER_TEST, groupName),
  );

  return assignment ? assignment[1] : SIGNUP_HEADER_VARIANT.CONTROL;
};

export default useSignupHeaderExperiment;
